module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "hcpRegister"
    }
  }, [(!_vm.isFinished) ? _c('div', {
    attrs: {
      "id": "hcpModal"
    }
  }, [_c('mu-stepper', {
    attrs: {
      "activeStep": _vm.activeStep
    }
  }, _vm._l((_vm.steps), function(step, stepIndex) {
    return _c('mu-step', {
      key: ("step-" + stepIndex)
    }, [_c('mu-step-label', [_vm._v("\n          " + _vm._s(step.label) + "\n        ")])], 1)
  }), 1), _vm._v(" "), _vm._l((_vm.steps), function(step, stepIndex) {
    return _c('mu-card', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (stepIndex === _vm.activeStep),
        expression: "stepIndex === activeStep"
      }],
      key: ("card-step-" + stepIndex)
    }, [_c('mu-card-header', [_c('div', {
      staticClass: "mu-card-title-container"
    }, [_c('div', {
      staticClass: "mu-card-title"
    }, [_vm._v("\n            " + _vm._s(step.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "mu-card-sub-title",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(step.subTitle))
      }
    })])]), _vm._v(" "), _c('mu-card-text', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (step.key === 'step1'),
        expression: "step.key === 'step1'"
      }]
    }, [_c('mu-row', [_c('mu-col', {
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "50"
      }
    }, [_c('mu-text-field', {
      attrs: {
        "hintText": "example@nhs.net",
        "label": "Your work email address",
        "type": "email",
        "fullWidth": ""
      },
      model: {
        value: (_vm.model.step1.work_email),
        callback: function($$v) {
          _vm.$set(_vm.model.step1, "work_email", $$v)
        },
        expression: "model.step1.work_email"
      }
    }), _vm._v(" "), (_vm.list.jobs.length) ? _c('mu-select-field', {
      attrs: {
        "label": "Your job title",
        "fullWidth": ""
      },
      model: {
        value: (_vm.model.step1.job_id),
        callback: function($$v) {
          _vm.$set(_vm.model.step1, "job_id", $$v)
        },
        expression: "model.step1.job_id"
      }
    }, _vm._l((_vm.list.jobs), function(job, jobIndex) {
      return _c('mu-menu-item', {
        key: ("job-" + jobIndex),
        attrs: {
          "value": job.job_id,
          "title": job.job_title
        }
      })
    }), 1) : _vm._e(), _vm._v(" "), _c('mu-auto-complete', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.listManualSurgery),
        expression: "!listManualSurgery"
      }],
      attrs: {
        "inputClass": "surgerySearchTxt",
        "maxHeight": 250,
        "scroller": _vm.scroller,
        "openOnFocus": true,
        "label": "Your surgery name",
        "fullWidth": "",
        "hintText": "Start typing to see results",
        "filter": "noFilter",
        "dataSource": _vm.list.surgeries,
        "dataSourceConfig": _vm.dataSourceConfig
      },
      on: {
        "change": _vm.handleSurgerySelected
      },
      model: {
        value: (_vm.surgerySearchValue),
        callback: function($$v) {
          _vm.surgerySearchValue = $$v
        },
        expression: "surgerySearchValue"
      }
    }), _vm._v(" "), _c('mu-checkbox', {
      staticClass: "listManualSurgery",
      attrs: {
        "label": 'My surgery isn\'t listed'
      },
      on: {
        "change": _vm.onListManualSurgery
      },
      model: {
        value: (_vm.listManualSurgery),
        callback: function($$v) {
          _vm.listManualSurgery = $$v
        },
        expression: "listManualSurgery"
      }
    }), _vm._v(" "), (_vm.listManualSurgery) ? _c('mu-row', [_c('mu-col', {
      attrs: {
        "desktop": "100",
        "tablet": "100",
        "width": "100"
      }
    }, [_c('h2', [_vm._v("Manually enter surgery address")])]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "desktop": "50",
        "tablet": "50",
        "width": "100"
      }
    }, [_c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-rules": 'required',
        "data-vv-name": "surgery",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "surgery",
        "errorText": _vm.errors.first('surgery'),
        "hintText": "Surgery name",
        "label": "Surgery name"
      },
      model: {
        value: (_vm.model.step1.surgery.surgery_name),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "surgery_name", $$v)
        },
        expression: "model.step1.surgery.surgery_name"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-rules": 'required',
        "data-vv-name": "address_line_1",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "Address line 1",
        "errorText": _vm.errors.first('address_line_1'),
        "hintText": "Address line 1",
        "label": "Address line 1"
      },
      model: {
        value: (_vm.model.step1.surgery.address_line_1),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "address_line_1", $$v)
        },
        expression: "model.step1.surgery.address_line_1"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
      attrs: {
        "hintText": "Address line 2",
        "label": "Address line 2"
      },
      model: {
        value: (_vm.model.step1.surgery.address_line_2),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "address_line_2", $$v)
        },
        expression: "model.step1.surgery.address_line_2"
      }
    }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('mu-col', {
      attrs: {
        "desktop": "50",
        "tablet": "50",
        "width": "100"
      }
    }, [_c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-rules": 'required',
        "data-vv-name": "surgery_postcode",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "surgery postcode",
        "errorText": _vm.errors.first('surgery_postcode'),
        "hintText": "Postcode/Zip",
        "label": "Postcode/Zip"
      },
      model: {
        value: (_vm.model.step1.surgery.postcode),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "postcode", $$v)
        },
        expression: "model.step1.surgery.postcode"
      }
    }), _vm._v(" "), _c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-rules": 'required',
        "data-vv-name": "surgery_city",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "surgery city",
        "errorText": _vm.errors.first('surgery_city'),
        "hintText": "City",
        "label": "City"
      },
      model: {
        value: (_vm.model.step1.surgery.city),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "city", $$v)
        },
        expression: "model.step1.surgery.city"
      }
    }), _vm._v(" "), _c('mu-text-field', {
      attrs: {
        "hintText": "County",
        "label": "County"
      },
      model: {
        value: (_vm.model.step1.surgery.county),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "county", $$v)
        },
        expression: "model.step1.surgery.county"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-col', {
      attrs: {
        "desktop": "100",
        "tablet": "100",
        "width": "100"
      }
    }, [(_vm.list.state.countries) ? _c('mu-select-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "scroller": _vm.scroller,
        "data-vv-rules": 'required',
        "data-vv-name": "country",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "country",
        "errorText": _vm.errors.first('relationship'),
        "underlineShow": _vm.underlineShow,
        "fullWidth": "",
        "maxHeight": 300,
        "hintText": "Select country",
        "label": 'I live in'
      },
      model: {
        value: (_vm.model.step1.country_id),
        callback: function($$v) {
          _vm.$set(_vm.model.step1, "country_id", $$v)
        },
        expression: "model.step1.country_id"
      }
    }, _vm._l((_vm.list.state.countries), function(item, index) {
      return _c('mu-menu-item', {
        key: 'country-' + index,
        attrs: {
          "value": item.country_id,
          "title": item.country_name
        }
      })
    }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "100",
        "tablet": "100",
        "desktop": "100"
      }
    }, [_c('div', {
      staticClass: "goals"
    }, [_c('h2', [_vm._v("What goals are you hoping to achieve by joining the Low Carb Program?")]), _vm._v(" "), _vm._l((_vm.list.goals), function(goal, goalIndex) {
      return _c('div', {
        key: ("goal-" + goalIndex),
        staticClass: "goal"
      }, [_c('mu-checkbox', {
        attrs: {
          "name": "goal",
          "nativeValue": '' + goal.goal_id + '',
          "label": goal.goal
        },
        model: {
          value: (_vm.model.step1.goals),
          callback: function($$v) {
            _vm.$set(_vm.model.step1, "goals", $$v)
          },
          expression: "model.step1.goals"
        }
      })], 1)
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "agreement"
    }, [_c('p', [_vm._v("By continuing, you agree to our "), _c('a', {
      attrs: {
        "href": (_vm.siteUrl + "terms")
      }
    }, [_vm._v("Terms & Conditions")]), _vm._v(" and that you have read our "), _c('a', {
      attrs: {
        "href": (_vm.siteUrl + "privacy")
      }
    }, [_vm._v("Privacy Policy")]), _vm._v(", including our cookie policy")])])])], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (step.key === 'step2'),
        expression: "step.key === 'step2'"
      }]
    }, [_c('p', [_vm._v("We accept the following file types: PDF, GIF, JPG and PNG")]), _vm._v(" "), _c('p', [_vm._v("The following types of documentation are accepted:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Passport")]), _vm._v(" "), _c('li', [_vm._v("Driving licence")]), _vm._v(" "), _c('li', [_vm._v("State-issued licence or ID card")]), _vm._v(" "), _c('li', [_vm._v("Medical ID")]), _vm._v(" "), _c('li', [_vm._v("Professional certification")])]), _vm._v(" "), _c('mu-flexbox', {
      attrs: {
        "id": "dropzone",
        "justify": "space-between",
        "align": "center"
      }
    }, [_c('mu-flexbox-item', {
      staticClass: "area"
    }, [_c('input', {
      attrs: {
        "type": "file",
        "id": "myFile",
        "multiple": "",
        "size": "1"
      },
      on: {
        "change": _vm.onFileChange
      }
    }), _vm._v(" "), (!_vm.hasSelectedFiles) ? _c('p', [_vm._v("Drag and drop a file here "), _c('br'), _vm._v(" or click to browse")]) : _vm._e(), _vm._v(" "), (_vm.hasSelectedFiles) ? _c('mu-row', _vm._l((_vm.model.step2.files), function(f, fileIndex) {
      return _c('mu-col', {
        key: ("file-" + fileIndex),
        attrs: {
          "width": "100",
          "tablet": "100",
          "desktop": "100"
        }
      }, [_c('mu-row', {
        staticClass: "file-row"
      }, [_c('mu-col', {
        attrs: {
          "width": "33",
          "tablet": "33",
          "desktop": "33"
        }
      }, [_c('span', {
        domProps: {
          "textContent": _vm._s(f.name)
        }
      })]), _vm._v(" "), _c('mu-col', {
        attrs: {
          "width": "33",
          "tablet": "33",
          "desktop": "33"
        }
      }, [_c('span', {
        domProps: {
          "textContent": _vm._s(_vm.convertSize(f.size))
        }
      })]), _vm._v(" "), _c('mu-col', {
        attrs: {
          "width": "33",
          "tablet": "33",
          "desktop": "33"
        }
      }, [_c('mu-icon-button', {
        staticClass: "removeFile",
        attrs: {
          "icon": "close"
        },
        on: {
          "click": function($event) {
            return _vm.removeFile(f)
          }
        }
      })], 1)], 1)], 1)
    }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "agreement"
    }, [_c('mu-checkbox', {
      attrs: {
        "label": "I confirm that I am the person represented in the submitted documents"
      },
      model: {
        value: (_vm.model.step2.agree),
        callback: function($$v) {
          _vm.$set(_vm.model.step2, "agree", $$v)
        },
        expression: "model.step2.agree"
      }
    })], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
      staticClass: "button",
      attrs: {
        "fullWidth": "",
        "label": _vm.isSaving ? 'Saving...' : 'Continue',
        "disabled": _vm.isSaving
      },
      on: {
        "click": _vm.nextStep
      }
    })], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isFinished) ? _c('div', {
    attrs: {
      "id": "hcpFinished"
    }
  }, [_c('mu-card', [_c('mu-card-header', [_c('mu-card-title', {
    attrs: {
      "title": "Thank you for verifying",
      "subTitle": 'Your ID documentation will be reviewed in the next 24 hours. You will recieve an email once your account is approved.'
    }
  })], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fabeabc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HealthCareProfessional/GettingStarted/GettingStarted.vue
// module id = 3805
// module chunks = 1